import React, { useContext, useState } from "react";
import dayjs from "dayjs";

import { Typography, Col, Row, Drawer, Space, Button, message, Popover } from "antd";
const { Text } = Typography;

import { DownloadOutlined, PlusOutlined, EyeOutlined } from "@ant-design/icons";
import { CompaniesContext } from "../contexts";
import { WaitingForACompany } from "../components/WaitingForACompany";
import { CardSelectable, ReportInvoicesNormalMode, TableReport } from "../components/reports";
import { get_invoices_for_report } from "../services";

import PropTypes from "prop-types";
import { currencyGetter } from "../utils/BankCurrencyUtils";
import { formatShownDate } from "../utils/Formaters";
import { downloadXlsx } from "../components/banks/templatesConverter";
import { InvoicesTypes } from "../constants";
import { formatCurrency } from "../components/banks/utils";

export const ReportsInvoices = ({ token, user }) => {
	const { selectedCompany: company } = useContext(CompaniesContext);	

	const [openGenerateEmailReport, setOpenGenerateEmailReport] = useState(false);
	const [openInvoicesReceivableReport, setOpenInvoicesReceivableReport] = useState(false);
	const [openBillsToPlayReport, setOpenBillsToPlayReport] = useState(false);
	const [openInvoiceJournal, setOpenInvoiceJournal] = useState(false);

	const [dataToProcess, setDataToProcess] = useState([]);

	const [loading, setLoading] = useState(false);

	const fetchInvoicesForReport = async (position, setOpen = () => {}) => {
		setOpen(true);
		setLoading(true);
		setDataToProcess([]);

		try {
			const response = await get_invoices_for_report(token, company.tid, position);

			if(response){
				setDataToProcess(response);
			}
		} catch (err) {
			message.error(err.response.data);
		} finally {
			setLoading(false);
		}
	};

	const loadMoreInvoices = async(position) => {
		setLoading(true);		

		const updateData = (newData) => {
			const amountNewInvoices = newData.length;

			if(amountNewInvoices === 0){
				message.info("No hay más facturas que agregar");
				return;
			}
			
			message.info(`${amountNewInvoices} Facturas Agregadas`);
			setDataToProcess([...dataToProcess, ...newData]);
		};
		
		try {
			const lastInvoiceId = dataToProcess[dataToProcess.length - 1].id;
			const response = await get_invoices_for_report(token, company.tid, position, lastInvoiceId);

			if(response){
				updateData(response);
			}
		} catch (err) {
			message.error(err.response.data);
		} finally {
			setLoading(false);
		}
	};

	const columnsInvoices = [
		{
			title: "Fecha",
			dataIndex: "date",
			width: 50,										
			fixed: "left",
			align: "center",
			render: (value) => (
				<Text>{formatShownDate(value)}</Text>
			),
		},		
		{
			title: "Serie",
			dataIndex: "reference",
			width: 65,										
			fixed: "left",
			align: "center",
			render: (value) => (
				<Text>{value}</Text>
			),
		},
		{
			title: "Número",
			dataIndex: "number",
			width: 65,										
			fixed: "left",
			align: "center",
			render: (value) => (
				<Text>{value}</Text>
			),
		},		
		{
			title: "Tipo",
			dataIndex: "type",
			width: 65,										
			fixed: "left",
			align: "center",
			render: (value) => (
				<Text>{value}</Text>
			),
		},
		{
			title: "Estado",
			dataIndex: "state",
			width: 65,										
			fixed: "left",
			align: "center",
			render: (value) => (
				<Text>{InvoicesTypes[value]}</Text>
			),
		},
	];

	const columnsInvoicesOut = [
		{
			title: "Nit Emisor",
			dataIndex: "sender_id",
			width: 60,										
			fixed: "left",
			align: "center",
			render: (value) => (
				<Text>{value}</Text>
			),
		},
		{
			title: "Nombre Emisor",
			dataIndex: "sender_name",
			width: 100,										
			fixed: "left",
			align: "center",
			render: (value) => (
				<Text>{value}</Text>
			),
		},
	];

	const columnsInvoicesIn = [
		{
			title: "Nit Receptor",
			dataIndex: "receptor_id",
			width: 60,										
			fixed: "left",
			align: "center",
			render: (value) => (
				<Text>{value}</Text>
			),
		},
		{
			title: "Nombre Receptor",
			dataIndex: "receptor_name",
			width: 100,										
			fixed: "left",
			align: "center",
			render: (value) => (
				<Text>{value}</Text>
			),
		},
	];

	const columnsInvoicesFinalPart = [
		{
			title: "Nombre Establecimiento",
			dataIndex: "establishment_name",
			width: 100,										
			fixed: "left",
			align: "center",
			render: (value) => (
				<Text>{value}</Text>
			),
		},
		{
			title: "Estado Pago",
			dataIndex: "reconciliation_not_payed",
			width: 100,										
			fixed: "left",
			align: "center",
			render: (value) => (
				<Text>{value ? "No Pagado" : "Pagado Parcialmente"}</Text>
			),
		},
		{
			title: "Cantidad Pagado",
			dataIndex: "reconciliation_total",
			width: 100,										
			fixed: "left",
			align: "center",
			render: (value, record) => (				
				<Text>{`${currencyGetter[record?.currency]} ${formatCurrency(value)}`}</Text>
			),
		},		
		{
			title: "Total",
			dataIndex: "total",
			width: 100,										
			fixed: "left",
			align: "center",
			render: (value, record) => (
				<Text>{`${currencyGetter[record?.currency]} ${formatCurrency(value)}`}</Text>
			),
		},
		{
			title: "Inpuestos",
			dataIndex: "taxes",
			width: 100,
			fixed: "left",
			align: "center",
			render: (value) => (
				<Text>{value}</Text>
			),
		},		
	];

	const columnsNotVisibleInvoices = [
		{
			title: "Acciones",
			dataIndex: "actions",
			width: 50,
			fixed: "left",
			align: "center",
			render: () => (
				// TODO: Use the InvoiceView Component or similar for show the data.
				<Popover placement="leftTop" title="Ver Más">
					<Button 
						variant="outlined"
						type="primary"
						// onClick={()}
					>					
						<EyeOutlined />
					</Button>
				</Popover>
			),
		}
	];

	const downloadFileXlsx = (positionConsult = "") => {
		if(dataToProcess.length === 0){
			message.error("No hay data que descargar");
			return;
		}
		
		const extendedColumnsFinalPart = [...columnsInvoicesFinalPart, 
			{
				title: "URL",
				dataIndex: "url",
				width: 100,										
				fixed: "left",
				align: "center",
				render: (value) => (
					<Text>{value}</Text>
				),
			}
		];
		
		const headers = [
			...columnsInvoices.map(({ title }) => title),
			...(positionConsult === "out" ? columnsInvoicesOut.map(({ title }) => title) : columnsInvoicesIn.map(({ title }) => title)),
			...extendedColumnsFinalPart.map(({ title }) => title),
		];
			
		const dataMatrix = [headers];
	
		dataToProcess.forEach((item) => {
			const baseColumns = columnsInvoices.map(({ dataIndex }) => item[dataIndex]);
	
			const dynamicColumns = item.position === "out"
				? columnsInvoicesOut.map(({ dataIndex }) => item[dataIndex])
				: columnsInvoicesIn.map(({ dataIndex }) => item[dataIndex]);
	
			const finalColumns = extendedColumnsFinalPart.map(({ dataIndex, render }) =>
				render ? render(item[dataIndex], item)?.props.children : item[dataIndex]
			);
	
			const row = [...baseColumns, ...dynamicColumns, ...finalColumns];
			dataMatrix.push(row);
		});
	
		// Descargar el archivo
		const today = dayjs(new Date());
		const positionkind = positionConsult === "out" ? "Por_Pagar" : "Por_Cobrar";
		const nameFile = `_Report_Facturas_${positionkind}_${today.format("YYYY-MM-DD HH:mm:ss")}-Company_${company.name}-${company.tid}`;
		downloadXlsx(dataMatrix, nameFile);
	};
	
	const ReportsTransactionsMenu = (
		<>
			<Row gutter={16} style={{ marginTop: "7%", marginRight: "10%", marginLeft: "10%", justifyContent: "center" }}>
				<Col xs={24} sm={24} md={24}>
					<CardSelectable
						title="Generación de Reporte de Facturas via Email/Correo"
						description="Puedes seleccionar un estado en específico junto a las fechas que necesites."												
						onClick={() => setOpenGenerateEmailReport(true)}
					/>
				</Col>
				<Col xs={24} sm={12} md={12} style={{ marginTop: "20px" }}>
					<CardSelectable
						title="Facturas Por Cobrar"
						description="Facturas de venta no pagadas o parcialmente pagadas."
						onClick={() => fetchInvoicesForReport("in", setOpenInvoicesReceivableReport)}
					/>
				</Col>
				<Col xs={24} sm={12} md={12} style={{ marginTop: "20px" }}>
					<CardSelectable
						title="Facturas Por Pagar"
						description="Facturas de compra no pagadas o parcialmente pagadas."
						onClick={() => fetchInvoicesForReport("out", setOpenBillsToPlayReport)}
					/>
				</Col>
				<Col xs={24} sm={24} md={24} style={{ marginTop: "20px" }}>
					<CardSelectable
						title="Generación de Libros de Facturas via Email/Correo"
						description="Puedes seleccionar un estado en específico junto a las fechas que necesites."		
						onClick={() => {setOpenInvoiceJournal(true);}}
					/>
				</Col>
			</Row>
		</>
	);
	
	const GenerateEmailReportDrawer = (
		<Drawer			
			title="Generación de Reporte de Facturas via Email/Correo"
			placement="right"
			width={"70vh"}
			open={openGenerateEmailReport}
			onClose={() => setOpenGenerateEmailReport(false)}
		>
			<ReportInvoicesNormalMode 
				user={user}
				token={token} 
				company={company} 
				onEmailSended={(value) => {
					if(!value) return;
					setOpenGenerateEmailReport(false);				
				}}
			/>
		</Drawer>
	);

	const InvoicesReceivableDrawer = (
		<Drawer
			title="Facturas por Cobrar"
			placement="right"
			width={"100%"}
			open={openInvoicesReceivableReport}
			onClose={() => setOpenInvoicesReceivableReport(false)}
			extra={
				<Space>
					<Button
						type="primary"
						icon={<PlusOutlined />}
						loading={loading}
						disabled={dataToProcess.length === 0}
						onClick={() => loadMoreInvoices("in")}
					>Cargar Más Facturas</Button>
					<Button
						type="primary"
						icon={<DownloadOutlined />}
						loading={loading}
						onClick={() => downloadFileXlsx("in")}
					>Descargar Reporte</Button>
				</Space>
			}
		>
			<TableReport
				data={dataToProcess}
				columns={[...columnsInvoices, ...columnsInvoicesIn, ...columnsInvoicesFinalPart, ...columnsNotVisibleInvoices]}
				loading={loading}
			/>
		</Drawer>
	);
	
	const BillsToPayDrawer = (
		<Drawer
			title="Facturas por Pagar"
			placement="right"
			width={"100%"}
			open={openBillsToPlayReport}
			onClose={() => setOpenBillsToPlayReport(false)}
			extra={
				<Space>
					<Button
						type="primary"
						icon={<PlusOutlined />}
						loading={loading}		
						disabled={dataToProcess.length === 0}				
						onClick={() => loadMoreInvoices("out")}
					>Cargar Más Facturas</Button>
					<Button
						type="primary"
						icon={<DownloadOutlined />}
						loading={loading}
						onClick={() => downloadFileXlsx("out")}
					>Descargar Reporte</Button>
				</Space>
			}
		>
			<TableReport
				data={dataToProcess}
				columns={[...columnsInvoices, ...columnsInvoicesOut, ...columnsInvoicesFinalPart]}
				loading={loading}
			/>
		</Drawer>
	);

	const InvoiceJournalDrawer = (
		<Drawer			
			title="Generación de Libros"
			placement="right"
			width={"70vh"}
			open={openInvoiceJournal}
			onClose={() => setOpenInvoiceJournal(false)}
		>
			<ReportInvoicesNormalMode 
				user={user}
				token={token} 
				company={company}
				journal={true}
				onEmailSended={(value) => {
					if(!value) return;
					setOpenInvoiceJournal(false);				
				}}
			/>
		</Drawer>
	);
	
	return (
		<>
			{/* Menu Select */}
			<WaitingForACompany company_id={company.id}/>
			{company.id !== "" && ReportsTransactionsMenu}

			{/* Drawers to Show */}
			{GenerateEmailReportDrawer}
			{InvoicesReceivableDrawer}
			{BillsToPayDrawer}
			{InvoiceJournalDrawer}
		</>
	);
};

ReportsInvoices.propTypes = {
	user: PropTypes.object.isRequired,
	token: PropTypes.string.isRequired,
};